import { getLocale } from "../runtime";

const sv_notfoundtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Sidan hittades inte`
};

const notfoundtitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notfoundtitle(inputs)
	return "notFoundTitle";
};

export { notfoundtitle as "notFoundTitle" };